import React, { useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { LiaSearchSolid } from "react-icons/lia";
import PatientSearch from "../PatientSearch/PatientSearch";
import useTitanApp from "../../hooks/useTitanApp";
import TitanLightSVG from "./../../assets/images/Titanverse_Logo_White.svg";
import TitanDarkSVG from "./../../assets/images/Titanverse_Logo_Black.svg";

export default function PharmacyTabs({
  value,
  handleChange,
  getServicesCount,
}) {
  const { appState } = useTitanApp();
  const { isAppLoading, isTabLoading, features, currentPharmacyId, darkMode } =
    appState || {};
  const {
    ifMapEnabled,
    ifPharmacyDashboardEnabled,
    ifPatientListEnabled,
    ifPatientSearchEnabled,
  } = features;

  const homeIcon = (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.01742 0.570677L13.5174 5.6476C13.825 5.93156 14 6.33116 14 6.7498V14.312C14 14.8643 13.5523 15.312 13 15.312H9.5C8.94772 15.312 8.5 14.8643 8.5 14.312V9.81197H5.5V14.312C5.5 14.8643 5.05228 15.312 4.5 15.312H1C0.447715 15.312 0 14.8643 0 14.312V6.7498C0 6.33116 0.174957 5.93156 0.48258 5.6476L5.98258 0.570677C6.55717 0.0402838 7.44283 0.0402838 8.01742 0.570677ZM7.33914 1.30548C7.14761 1.12868 6.85239 1.12868 6.66086 1.30548L1.16086 6.3824C1.05832 6.47706 1 6.61026 1 6.7498V14.312H4.5V9.81197C4.5 9.25969 4.94772 8.81197 5.5 8.81197H8.5C9.05228 8.81197 9.5 9.25969 9.5 9.81197V14.312H13V6.7498C13 6.61026 12.9417 6.47706 12.8391 6.3824L7.33914 1.30548Z"
        className="icons-color"
      />
    </svg>
  );

  const overviewIcon = (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6401 6.96504C13.3921 6.96504 14.0017 7.57464 14.0017 8.32661V13.3838C14.0017 14.1358 13.3921 14.7454 12.6401 14.7454H9.13898C8.38701 14.7454 7.77742 14.1358 7.77742 13.3838V8.32661C7.77742 7.57464 8.38701 6.96504 9.13898 6.96504H12.6401ZM4.87394 10.0869C5.62591 10.0869 6.2355 10.6964 6.2355 11.4484V13.3838C6.2355 14.1358 5.62591 14.7454 4.87394 14.7454H1.36156C0.609593 14.7454 0 14.1358 0 13.3838V11.4484C0 10.6964 0.609593 10.0869 1.36156 10.0869H4.87394ZM12.6401 8.1321H9.13898C9.03156 8.1321 8.94447 8.21918 8.94447 8.32661V13.3838C8.94447 13.4913 9.03156 13.5784 9.13898 13.5784H12.6401C12.7476 13.5784 12.8347 13.4913 12.8347 13.3838V8.32661C12.8347 8.21918 12.7476 8.1321 12.6401 8.1321ZM4.87394 11.2539H1.36156C1.25414 11.2539 1.16705 11.341 1.16705 11.4484V13.3838C1.16705 13.4913 1.25414 13.5784 1.36156 13.5784H4.87394C4.98136 13.5784 5.06845 13.4913 5.06845 13.3838V11.4484C5.06845 11.341 4.98136 11.2539 4.87394 11.2539ZM4.86273 0.739441C5.6147 0.739441 6.22429 1.34903 6.22429 2.101V7.15824C6.22429 7.87261 5.67413 8.45849 4.9744 8.51529L4.86273 8.51981H1.36156C0.609593 8.51981 0 7.91021 0 7.15824V2.101C0 1.34903 0.609593 0.739441 1.36156 0.739441H4.86273ZM4.86273 1.9065H1.36156C1.25414 1.9065 1.16705 1.99358 1.16705 2.101V7.15824C1.16705 7.26567 1.25414 7.35275 1.36156 7.35275H4.86273L4.90733 7.34761C4.99326 7.32746 5.05724 7.25032 5.05724 7.15824V2.101C5.05724 1.99358 4.97015 1.9065 4.86273 1.9065ZM12.6401 0.739441C13.3921 0.739441 14.0017 1.34903 14.0017 2.101V4.0461C14.0017 4.79807 13.3921 5.40766 12.6401 5.40766H9.13898C8.38701 5.40766 7.77742 4.79807 7.77742 4.0461V2.101C7.77742 1.34903 8.38701 0.739441 9.13898 0.739441H12.6401ZM9.13898 1.9065C9.03156 1.9065 8.94447 1.99358 8.94447 2.101V4.0461C8.94447 4.15352 9.03156 4.24061 9.13898 4.24061H12.6401C12.7476 4.24061 12.8347 4.15352 12.8347 4.0461V2.101C12.8347 1.99358 12.7476 1.9065 12.6401 1.9065H9.13898Z"
        className="icons-color"
      />
    </svg>
  );

  const servicesIcon = (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.03647 0.0112305C7.86597 0.0112305 7.71325 0.0873406 7.61043 0.207438L7.55411 0.248056C5.86716 -0.248021 3.95327 0.135648 2.61735 1.39906C1.43278 2.51934 0.979608 4.06938 1.25782 5.51849L1.24059 5.53455L0.487971 6.24633C-0.160379 6.85949 -0.160378 7.85362 0.487971 8.46678C0.872377 8.83033 1.39839 8.97833 1.89809 8.91078C1.96999 9.17217 2.11421 9.41945 2.33074 9.62424C2.62367 9.90126 2.99882 10.0531 3.38189 10.0798C3.41008 10.4422 3.57067 10.7971 3.86365 11.0742C4.15664 11.3512 4.53189 11.5031 4.91506 11.5298C4.94321 11.8922 5.1038 12.2472 5.39683 12.5243C5.9924 13.0875 6.92788 13.1334 7.57879 12.6618L7.94852 13.0115C8.60004 13.6277 9.65637 13.6277 10.3079 13.0115C10.5998 12.7354 10.7609 12.3826 10.7912 12.0219C11.1718 11.9938 11.5441 11.8421 11.8353 11.5667C12.1274 11.2905 12.2878 10.9372 12.3169 10.5762C12.6929 10.5457 13.06 10.3944 13.3479 10.1221C13.5743 9.90794 13.7217 9.64738 13.79 9.3728C14.2823 9.43222 14.7973 9.28316 15.1754 8.92563C15.8237 8.31247 15.8237 7.31833 15.1754 6.70517L14.5096 6.0755L14.6365 5.60542C14.9311 4.51386 14.7822 3.35829 14.2227 2.36875C13.3978 0.909745 11.8024 0.0149952 10.0839 0.014995L8.94377 0.0149948C8.89243 0.0124935 8.84081 0.0112305 8.78893 0.0112305H8.03647ZM12.9385 6.1303L13.4838 6.66703C13.5181 6.70075 13.556 6.72947 13.5966 6.7529L14.3608 7.47557C14.5592 7.66325 14.5592 7.96754 14.3608 8.15522C14.1623 8.3429 13.8406 8.3429 13.6421 8.15522L12.3644 6.9469C12.1395 6.73416 11.7748 6.73416 11.5498 6.9469L11.5371 6.95889C11.3122 7.17163 11.3122 7.51655 11.5371 7.72929L12.5333 8.67141C12.732 8.85925 12.732 9.16381 12.5333 9.35166C12.3521 9.52306 12.0671 9.53828 11.8683 9.39635C11.6381 9.23205 11.3149 9.25405 11.112 9.44785C10.9091 9.64165 10.889 9.9475 11.0649 10.1636C11.2182 10.3518 11.2032 10.6237 11.0207 10.7963C10.8371 10.9699 10.5472 10.9832 10.3481 10.8354C10.1193 10.6657 9.79267 10.6838 9.58645 10.8777C9.38023 11.0715 9.35912 11.3804 9.53723 11.5977C9.69381 11.7888 9.67887 12.0656 9.49328 12.2411C9.29166 12.4318 8.96476 12.4318 8.76314 12.2411L8.40364 11.9011L8.49733 11.8125C9.14568 11.1993 9.14568 10.2052 8.49733 9.59206C8.20434 9.31497 7.82909 9.1631 7.44592 9.13644C7.41777 8.77401 7.25718 8.41906 6.96415 8.14193C6.67123 7.86491 6.29608 7.71304 5.913 7.68633C5.88481 7.32397 5.72423 6.96909 5.43124 6.69201C5.04684 6.32846 4.52082 6.18047 4.02112 6.24801C3.94922 5.98662 3.80501 5.73934 3.58847 5.53455C3.24869 5.21322 2.79828 5.06028 2.35319 5.07575C2.23263 4.03995 2.59222 2.96364 3.43196 2.16947C4.22572 1.41879 5.28602 1.07384 6.32474 1.1346L5.09719 2.01982C4.29922 2.59527 4.15045 3.69596 4.76703 4.4626C5.36919 5.2113 6.47759 5.36111 7.2569 4.79912L8.76601 3.71085L10.3802 3.71085L12.9385 6.1303ZM5.753 2.92924L8.24462 1.13244H8.78893C8.82605 1.13244 8.86288 1.13344 8.89939 1.1354C8.90941 1.13594 8.91943 1.13621 8.92946 1.13621L10.0839 1.13621C11.4201 1.13621 12.6312 1.83204 13.2467 2.92058C13.642 3.61968 13.7595 4.42426 13.584 5.19251L11.103 2.75069C10.9981 2.64748 10.8569 2.58964 10.7098 2.58964L8.58496 2.58964C8.46725 2.58964 8.35253 2.62669 8.25705 2.69554L6.60109 3.88971C6.30547 4.10289 5.86915 4.04392 5.64073 3.75991C5.42674 3.49384 5.47605 3.12895 5.753 2.92924ZM6.96592 10.3607C7.16452 10.1748 7.48488 10.1754 7.68272 10.3625C7.88117 10.5501 7.88117 10.8544 7.68272 11.0421L6.9301 11.7539C6.73165 11.9416 6.4099 11.9416 6.21145 11.7539C6.013 11.5662 6.013 11.2619 6.21145 11.0742L6.96592 10.3607ZM6.15135 9.59026L5.39692 10.3038C5.19847 10.4914 4.87672 10.4914 4.67827 10.3038C4.48376 10.1198 4.47989 9.82383 4.66667 9.63543L4.67862 9.62424L5.43124 8.91246L5.44291 8.90132C5.64213 8.72473 5.95505 8.7284 6.14954 8.91233C6.34738 9.09944 6.34798 9.40245 6.15135 9.59026ZM4.61627 8.14193L3.86365 8.8537L3.85198 8.86485C3.65277 9.04144 3.33985 9.03777 3.14536 8.85383C2.94691 8.66615 2.94691 8.36186 3.14536 8.17418L3.89797 7.46241C4.09643 7.27473 4.41818 7.27473 4.61663 7.46241C4.81114 7.64636 4.815 7.94234 4.62822 8.13074L4.61627 8.14193ZM2.77386 6.98461L2.02124 7.69638C1.82279 7.88406 1.50104 7.88406 1.30258 7.69638C1.10413 7.5087 1.10413 7.20441 1.30258 7.01673L2.0552 6.30496C2.25365 6.11728 2.5754 6.11728 2.77386 6.30496C2.97231 6.49264 2.97231 6.79693 2.77386 6.98461Z"
        className="icons-color"
      />
    </svg>
  );

  const [isSearchIconClicked, setSearchIconClicked] = useState(false);

  const handleSearchIconClick = () => {
    setSearchIconClicked(true);
  };

  const handleCrossIconClick = () => {
    setSearchIconClicked(false); // Set the state to false when the cross icon is clicked
  };

  return (
    <>
      <div className="top-block">
        {darkMode ? <TitanLightSVG /> : <TitanDarkSVG />}
        <Tabs
          value={value}
          className="tabs_top"
          onChange={handleChange}
          aria-label="Tabs"
          TabIndicatorProps={{
            className: "tab_indicator_line",
            tabbartabstyle: {
              width: "auto",
              padding: 0,
              marginRight: 32,
            },
          }}
        >
          {ifMapEnabled === true && (
            <Tab
              icon={homeIcon}
              className="homeIcon"
              disabled={isAppLoading || isTabLoading}
            />
          )}

          {ifPharmacyDashboardEnabled === true && (
            <Tab
              disabled={isAppLoading || isTabLoading}
              icon={overviewIcon}
              iconPosition="start"
              label={<span className={`tabs_text`}>Overview</span>}
            />
          )}

          {ifPatientListEnabled === true && (
            <Tab
              disabled={isAppLoading || isTabLoading}
              icon={overviewIcon}
              iconPosition="start"
              label={<span className={`tabs_text`}>Patients</span>}
            />
          )}

          <Tab
            disabled={isAppLoading || isTabLoading}
            icon={servicesIcon}
            iconPosition="start"
            label={
              <span className={`tabs_text notification-serv`}>
                Services
                {getServicesCount > 0 ? (
                  <div className="notification-count">
                    <p>{getServicesCount > 0 ? getServicesCount : 0}</p>
                  </div>
                ) : (
                  ""
                )}
              </span>
            }
          />

          {isAppLoading === false &&
            isTabLoading === false &&
            ifPatientSearchEnabled === true && (
              <div className="searchIc" onClick={handleSearchIconClick}>
                <LiaSearchSolid size={20} className="icons-color" />
                <p>Search</p>
              </div>
            )}
        </Tabs>
      </div>

      {isSearchIconClicked ? (
        <div className="patientSearchModal">
          <PatientSearch
            show={isSearchIconClicked}
            setShow={isSearchIconClicked}
            handleCrossIconClick={handleCrossIconClick}
            pharmacyId={currentPharmacyId}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

